import type { FC } from 'react';

import type { OfferItem, OfferRewardItem } from '../type';

import { Body } from './body';
import { Footer } from './footer';
import { Header } from './header';

export interface OfferReviewProps {
  id: string;
  title: string;
  items: OfferItem[] | undefined;
  rewardItems?: OfferRewardItem[];
  endDate: string | Date | undefined;
  vipPoints: number | undefined;
  disabled?: boolean;
  onClose?: () => void;
  actionBtn: React.ReactNode;
  rewards?: string[];
  progress?: number;
  isAggregate?: boolean;
  onItemClick?: (id: string) => void;
  storeItemDescription: string | undefined;
  isSingleContent?: boolean;
}

export const OfferReview: FC<Readonly<OfferReviewProps>> = ({
  title,
  items,
  rewardItems,
  endDate,
  vipPoints,
  actionBtn,
  rewards,
  isAggregate,
  onItemClick,
  storeItemDescription,
  isSingleContent = false,
}) => {
  return (
    <>
      <Header endDate={endDate} isAggregate={isAggregate} title={title} />
      <Body
        isAggregate={isAggregate}
        isSingleContent={isSingleContent}
        items={items}
        onItemClick={onItemClick}
        rewardItems={rewardItems}
        storeItemDescription={storeItemDescription}
        vipPoints={vipPoints}
      />
      <Footer
        actionBtn={actionBtn}
        isSingleContent={isSingleContent}
        rewards={rewards ?? []}
      />
    </>
  );
};
